import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useState } from 'react'
import { FiAward } from 'react-icons/fi'

import { SectionCard } from '../../../components/SectionCard'
import { SearchableSelect } from '../../../components/Select'
import { IContestForSelect } from '../../../services/Contests/interfaces'

const MotionSectionCard = motion(SectionCard)

interface IContestSelectionGateProps {
  contests: IContestForSelect[]
  onSelect: (contestId: string) => void
  readOnly?: boolean
}

export default function ContestSelectionGate({ contests, onSelect, readOnly = false }: IContestSelectionGateProps) {
  const [selected, setSelected] = useState('')

  const handleConfirm = () => {
    if (selected) onSelect(selected)
  }

  return (
    <MotionSectionCard
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 0.61, 0.36, 1] }}
      p={{ base: '8', md: '12' }}
      maxW="560px"
      mx="auto"
      mt={{ base: '6', md: '12' }}
      textAlign="center"
      boxShadow="0 8px 24px -8px rgba(17,24,39,0.06)"
    >
      <Flex
        mx="auto"
        mb="5"
        align="center"
        justify="center"
        w="64px"
        h="64px"
        borderRadius="16px"
        bg="magenta.50"
        color="magenta.500"
        fontSize="28px"
      >
        <FiAward />
      </Flex>
      <Heading
        as="h2"
        fontFamily="Inter, sans-serif"
        fontSize={{ base: '22px', md: '26px' }}
        fontWeight="700"
        letterSpacing="-0.02em"
        color="gray.900"
        mb="2"
      >
        {readOnly ? 'Qual concurso você quer visualizar?' : 'Qual concurso você quer avaliar?'}
      </Heading>
      <Text variant="caption" mb="6">
        {readOnly
          ? 'Selecione o concurso para consultar as notas das obras.'
          : 'Selecione o concurso para acessar suas obras e os avaliadores cadastrados.'}
      </Text>

      <Box textAlign="left" mb="5">
        <SearchableSelect
          isClearable
          placeholder="Selecione um concurso"
          entity="concurso"
          options={contests.map((contest) => ({ value: contest.id.toString(), label: contest.name }))}
          value={selected}
          onChange={setSelected}
        />
      </Box>

      <Button
        onClick={handleConfirm}
        isDisabled={!selected}
        bg="magenta.500"
        color="white"
        fontSize="14px"
        fontWeight="600"
        borderRadius="10px"
        h="44px"
        w="100%"
        _hover={{ bg: 'magenta.600' }}
        _active={{ transform: 'scale(0.99)' }}
        sx={{ transition: 'all .15s ease' }}
      >
        Continuar
      </Button>
    </MotionSectionCard>
  )
}
